export function loadAxonScripts(eventKey) {
  const scripts = [
    'https://s.axon.ai/pixel.js',
    'https://c.albss.com/p/l/loader.iife.js',
  ];

  if (!window.axon) {
    const axon = (window.axon = function () {
      axon.performOperation
        ? axon.performOperation.apply(axon, arguments)
        : axon.operationQueue.push(arguments);
    });

    axon.operationQueue = [];
    axon.ts = Date.now();
    axon.eventKey = eventKey;

    const firstScript = document.getElementsByTagName('script')[0];
    scripts.forEach(src => {
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.src = src;
      firstScript.parentNode.insertBefore(scriptElement, firstScript);
    });
  }
}
